import devConfig from './keycloak.dev.json';
import prodConfig from './keycloak.prod.json';

// Definizione dell'interfaccia per la configurazione di Keycloak
interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

const env = process.env.REACT_APP_ENV || 'development';

let keycloakConfig: KeycloakConfig;

switch (env) {
  case 'production':
    keycloakConfig = prodConfig as KeycloakConfig;
    break;
  case 'development':
  default:
    keycloakConfig = devConfig as KeycloakConfig;
}

console.log(`Using ${env} environment for Keycloak configuration`);

export default keycloakConfig;